/* eslint-disable @typescript-eslint/ban-types */
import { FormControlLabel, Switch } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { renderErrorInField, renderUpdatedInField } from '@flatsy/utils/Functions/form/Helpers'
import FormTextField from '../../../../../../Global/TextField'
import { FieldsType, SingleFieldProps } from '../../../../../Types'
import { Body1 } from '../../../../../../../MaterialUi/Typo'
import { useStyles } from './Style'
import { getValue } from './Utils'

const CalendarInstruction = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const max = 500
  const [switchValue, setswitchValue] = useState(false)

  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description event when input change
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = getValue(input)
    input.onChange({
      instructions_is_active: value.instructions_is_active,
      instructions: val.target.value,
    })
  }

  const onSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = getValue(input)
    input.onChange({
      instructions_is_active: event.target.checked,
      instructions: event.target.checked ? value.instructions : '',
    })
  }

  useEffect(() => {
    setswitchValue(getValue(input).instructions_is_active)
  }, [input])

  return (
    <>
      <Body1>{field.helper}</Body1>
      <FormControlLabel
        control={<Switch onChange={onSwitchChange} checked={switchValue} />}
        label="Activer les consignes de visites"
        className={classes.toggle}
      />
      {switchValue && (
        <FormTextField
          error={renderErrorInField(meta)}
          updated={renderUpdatedInField(meta, justSubmitted)}
          label={renderLabelInField(field, values)}
          {...input}
          value={getValue(input).instructions}
          onChange={onChange}
          fullWidth
          type="textarea"
          multiline
          className={classes.field}
          InputLabelProps={{ shrink: true }}
          placeholder={field.placeholder}
          helperText={`${
            getValue(input).instructions ? getValue(input).instructions.length : 0
          }/${max}`}
          inputProps={{
            maxlength: max,
          }}
        />
      )}
    </>
  )
}

export default CalendarInstruction
